import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { withRouter } from 'react-router-dom'

import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { UserDetailsWrapper } from 'Components/UserManagement/UserDetailsWrapper'
import { UserManagementDetailsEditForm } from '../../../../Containers/Form/UserManagement/UserDetails/Edit'
import { updateUserById, getUserById } from 'Reducers/Users/actions'
import { uploadProfileImage } from 'Reducers/Upload/actions'
import UserManagementIcon from 'Assets/Images/icons/userManagement'
import { PATHS } from 'Config/Routing/paths'
import { CONFIG } from 'Config/config'
import { isClientRole } from 'Utils/Validators/roles'
import StyledBreadcrumbs from '../../../../Components/StyledBreadcrumbs'

class UserManagementDetailsEdit extends PureComponent {
  constructor(props) {
    super(props)

    this.userManagementDetailsEditFormSubmit = this.userManagementDetailsEditFormSubmit.bind(
      this,
    )
    this.userManagementDetailsEditFormSuccess = this.userManagementDetailsEditFormSuccess.bind(
      this,
    )
  }

  renderBreadcrumbs() {
    return (
      <div>
        <StyledBreadcrumbs
          icon={<UserManagementIcon style={{ width: 24 }} />}
          breadcrumbs={[
            {
              label: 'User management',
              link: `${PATHS.main.dashboard}${PATHS.dashboard.userManagement}`,
            },
            { label: 'Edit' },
          ]}
        />
      </div>
    )
  }

  render() {
    return (
      <LayoutDashboard>
        {this.renderBreadcrumbs()}
        <UserDetailsWrapper>
          <UserManagementDetailsEditForm
            onSubmit={this.userManagementDetailsEditFormSubmit}
            userId={this.props.match.params.userId}
          />
        </UserDetailsWrapper>
      </LayoutDashboard>
    )
  }

  userManagementDetailsEditFormSubmit(values) {
    const { updateUserById, uploadProfileImage, getUserById } = this.props
    const { userId } = this.props.match.params

    const payload = imageUrl => {
      const additionalProp = { subrole: null }

      if (isClientRole(values.role)) {
        additionalProp.client_id = values.clientId
      } else {
        additionalProp.city_id = values.cityId
      }

      if (values.isCityManagerAssistant && CONFIG.USER_ROLE.CITY_MANAGER) {
        additionalProp.subrole = CONFIG.SUBROLES.ASSISTANT
      }

      return {
        client_id: '',
        city_id: '',
        first_name: values.firstName,
        last_name: values.lastName,
        mobile_phone: values.mobilePhone,
        email: values.email,
        business_number: values.businessNumber,
        role: values.role,
        status: values.status,
        profile_picture: imageUrl,
        ...additionalProp,
      }
    }
    const callbacks = {
      onSuccess: () => {
        getUserById(userId)
        this.userManagementDetailsEditFormSuccess()
      },
    }

    const imageFile = get(values, 'profilePicture[0]')
    if (imageFile.type) {
      uploadProfileImage(userId, imageFile, {
        onSuccess: imageUrl => {
          updateUserById(userId, payload(imageUrl), callbacks)
        },
      })
    } else {
      updateUserById(userId, payload(), callbacks)
    }
  }

  userManagementDetailsEditFormSuccess() {
    const { history } = this.props

    history.push(`${PATHS.main.dashboard}${PATHS.dashboard.userManagement}`)
  }
}

UserManagementDetailsEdit.propTypes = {
  updateUserById: PropTypes.func.isRequired,
  uploadProfileImage: PropTypes.func.isRequired,
  getUserById: PropTypes.func.isRequired,
}

export default connect(
  null,
  {
    updateUserById,
    uploadProfileImage,
    getUserById,
  },
)(withRouter(UserManagementDetailsEdit))
